<template>
  <v-row>
    <v-col cols="3">
      <p>از :</p>
      <date-picker simple editable v-model="from"></date-picker>
    </v-col>

    <v-col cols="3">
      <p>تا :</p>
      <date-picker simple editable v-model="to"></date-picker>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DeviceFilterDropDown",
  data() {
    return {
      from: "",
      to: ""
    };
  },
  methods: {
    clearFrom() {
      this.from = null;
    },
    clearTo() {
      this.to = null;
    }
  }
};
</script>

<style scoped>
/* Modal Content (image) */
</style>
